import Chart from "react-apexcharts";

const TotalSalesGraph = ({ type, height, options, series }) => {
    return (
        <>
            <Chart type={type} height={height} options={options} series={series} />
        </>
    );
};

export default TotalSalesGraph;
